export const links = {
  root: '/TransportPermits',
  rootWithCompany: '/TransportPermits/company',
  transports: 'transports',
  permits: 'permits',
};
